import React from 'react';
import { Lock } from 'lucide-react';
import { CONFIDENTIAITE_DATA } from '@/constants/data';
import styles from './confidentialie.module.css'; 

const ConfidentialiteComponent = () => {
  const { securityMessage, links } = CONFIDENTIAITE_DATA;

  const renderMessage = () => {
    return securityMessage.split(/(\{.*?\})/).map((part, index) => {
      if (part.startsWith('{') && part.endsWith('}')) {
        const key = part.slice(1, -1);
        const link = links[key as keyof typeof links];
        if (link) {
          return (
            <a key={index} href={link.url} className={styles.link}>
              {link.text}
            </a>
          );
        }
      }
      return part;
    });
  };

  return (
    <div className={styles.container}>
      <Lock size={20} /> 
      <p className={styles.message}>{renderMessage()}</p>
    </div>
  );
};

export default ConfidentialiteComponent;